import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import BackButton from "./BackButton";
import AreaClientiMenu from "./AreaClientiMenu";

const LINKS = [
  { href: "/", label: "Home" },
  { href: "/negozio", label: "Shop" },
  { href: "/guida", label: "Guida" },
  { href: "/chi-siamo", label: "Chi siamo" },
  { href: "/contatti", label: "Contatti" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (y < 80) setHidden(false);
      else if (Math.abs(y - last) > 8) setHidden(y > last);
      last = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = () => {
    setOpen(false);
    if (pathname === "/") window.scrollTo({ top: 0, behavior: "smooth" });
    else { navigate("/"); window.scrollTo(0, 0); }
  };
  const onBar = (e) => { if (e.target === e.currentTarget) goTop(); };
  const linkCls = (href) => `text-sm font-medium transition-colors whitespace-nowrap ${pathname === href ? "text-[#0F4C81]" : "text-stone-700 hover:text-[#0F4C81]"}`;

  return (
    <header className={`sticky top-0 z-50 bg-[#FAFAF7]/90 backdrop-blur-md border-b border-stone-200 transition-transform duration-300 ${hidden && !open ? "-translate-y-full" : "translate-y-0"}`} data-testid="navbar" data-hidden={hidden && !open ? "true" : "false"}>
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between cursor-pointer" onClick={onBar} data-testid="navbar-bar" title="Torna all'inizio">
        <div className="flex items-center gap-1" onClick={onBar}>
          <BackButton />
          <button type="button" onClick={goTop} className="flex items-center gap-2" data-testid="nav-logo" aria-label="Guatemalan Spirits, torna alla home">
            <Logo size={36} />
            <span className="font-serif text-lg font-bold text-[#0B2A45] leading-none">
              Guatemalan <span className="text-[#C2593F]">Spirits</span>
            </span>
          </button>
        </div>

        <nav className="hidden md:flex items-center gap-6" aria-label="Navigazione principale" onClick={onBar}>
          {LINKS.map((l) => (
            l.href === "/"
              ? <button key={l.href} type="button" onClick={goTop} className={linkCls("/")} data-testid="nav-link-home">{l.label}</button>
              : <Link key={l.href} to={l.href} className={linkCls(l.href)} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{l.label}</Link>
          ))}
          <AreaClientiMenu />
        </nav>

        <button className="md:hidden p-2" onClick={(e) => { e.stopPropagation(); setOpen(!open); }} data-testid="nav-mobile-toggle" aria-label={open ? "Chiudi menu" : "Apri menu"} aria-expanded={open} aria-controls="mobile-navigation">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <nav id="mobile-navigation" aria-label="Navigazione mobile" className="md:hidden border-t border-stone-200 bg-[#FAFAF7] px-6 py-4 space-y-3" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            l.href === "/"
              ? <button key={l.href} type="button" onClick={goTop} className="block text-base font-medium text-stone-700 hover:text-[#0F4C81]" data-testid="nav-mobile-link-home">{l.label}</button>
              : <Link key={l.href} to={l.href} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="block text-base font-medium text-stone-700 hover:text-[#0F4C81] transition-colors">{l.label}</Link>
          ))}
          <AreaClientiMenu mobile onNavigate={() => setOpen(false)} />
        </nav>
      )}
    </header>
  );
}
